/**
 * Scelta di un mese ("2026-11"), con un elenco al posto del campo del browser.
 *
 * `<input type="month">` non esiste su Safari del Mac: il browser lo mostra
 * come una normale casella di testo, senza calendario e senza tendina. Si
 * riesce a cliccarci dentro e non succede niente — che è esattamente il modo
 * peggiore di non funzionare. Un elenco di mesi funziona ovunque, si legge in
 * italiano e non lascia scrivere valori impossibili.
 */
const MESI = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno',
  'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];

const etichetta = (iso) => {
  const [a, m] = String(iso || '').split('-').map(Number);
  return m >= 1 && m <= 12 ? `${MESI[m - 1]} ${a}` : '';
};

/** Elenco di mesi attorno a oggi, con dentro anche quello già impostato. */
function opzioni(valore, indietro, avanti) {
  const oggi = new Date();
  const lista = [];
  for (let i = -indietro; i <= avanti; i++) {
    const d = new Date(oggi.getFullYear(), oggi.getMonth() + i, 1);
    lista.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`);
  }
  // Una competenza vecchia o lontana non deve sparire dall'elenco solo perché
  // cade fuori dalla finestra: altrimenti il campo mostrerebbe un altro mese.
  const v = String(valore || '').slice(0, 7);
  if (/^\d{4}-\d{2}$/.test(v) && !lista.includes(v)) lista.push(v);
  return lista.sort();
}

export default function SceltaMese({ value, onChange, className = 'input',
                                     disabled, vuoto, indietro = 18, avanti = 18, title }) {
  const v = String(value || '').slice(0, 7);
  return (
    <select className={className} value={v} disabled={disabled} title={title}
            onChange={e => onChange(e.target.value)}>
      {(vuoto || !v) && <option value="">{vuoto || '— scegli un mese —'}</option>}
      {opzioni(v, indietro, avanti).map(m => (
        <option key={m} value={m}>{etichetta(m)}</option>
      ))}
    </select>
  );
}
